import config from 'constants/config'
import { getImageUrl } from 'lib/image/imageUtils'

const EXPERIENCES_OG_IMAGE_ID = '4d3ab866-055a-476c-91f1-63baf6e57c1a'
const EXPERIENCES_OG_IMAGE_OPTIONS = { width: 1200, aspectRatio: '16:9', format: 'jpeg' as const }

interface ExperiencesHeadMetaParams {
  placeName?: string
  isAnywhere: boolean
}

interface ExperiencesHeadMeta {
  title: string
  description: string
  imageId: string
  imageUrl: string
  imageAlt: string
}

export function getExperiencesSearchHeadMeta({ placeName, isAnywhere }: ExperiencesHeadMetaParams): ExperiencesHeadMeta {
  const baseTitle = 'Browse our best handpicked experiences'
  const effectivePlaceName = placeName?.trim()
  const hasPlace = !!effectivePlaceName && !isAnywhere

  const title = hasPlace ? `${baseTitle} in ${effectivePlaceName}` : baseTitle
  const description = hasPlace
    ? `Discover unforgettable experiences in ${effectivePlaceName} with ${config.title}.`
    : `Discover unforgettable experiences with ${config.title}.`
  const imageAlt = hasPlace ? `${effectivePlaceName} experiences` : `${config.title} experiences`

  return {
    title,
    description,
    imageId: EXPERIENCES_OG_IMAGE_ID,
    imageUrl: getImageUrl(EXPERIENCES_OG_IMAGE_ID, EXPERIENCES_OG_IMAGE_OPTIONS),
    imageAlt,
  }
}

export { EXPERIENCES_OG_IMAGE_ID }
